export type LinkState = 'active' | 'expired' | 'revoked' | 'used_up' | 'suspended';

/** One row of GET /mobile-links (every field the details drawer shows comes from here). */
export interface MobileLinkRow {
  id: string;
  name: string;
  tokenPrefix: string;
  scopes: string[];
  locationId?: string | null;
  expiresAt: string;
  createdAt?: string;
  maxUses: number | null;
  useCount: number;
  lastUsedAt: string | null;
  state: LinkState;
  suspendedReason?: string | null;
  maxSaleAmount?: number | null;
  maxSalesPerHour?: number | null;
  dailyTotalCap?: number | null;
  allowedFromMinute?: number | null;
  allowedToMinute?: number | null;
  allowedCidrs?: string[] | null;
  bindDevice?: boolean;
  maxDiscountPercent?: number | null;
  maxDiscountAmount?: number | null;
  /** POS-I276 fills these; absent until then. */
  liveSessions?: number | null;
  lastSeenAt?: string | null;
  createdBy: { id: string; firstName: string | null; lastName: string | null; email: string } | null;
}

export interface ActivityRow {
  id: string;
  action: string;
  createdAt: string;
  ipAddress: string | null;
  userAgent: string | null;
  newValues: {
    outcome?: string; reason?: string; code?: string; linkName?: string | null; discountType?: string; discountValue?: number | null;
    percent?: number | null; amount?: number | null; subtotal?: number | null; count?: number;
  } | null;
}

export const STATE_TONE: Record<LinkState, 'success' | 'warning' | 'danger' | 'outline'> = {
  active: 'success',
  expired: 'warning',
  revoked: 'danger',
  used_up: 'outline',
  suspended: 'warning',
};

export const creatorName = (l: Pick<MobileLinkRow, 'createdBy'>): string =>
  l.createdBy ? [l.createdBy.firstName, l.createdBy.lastName].filter(Boolean).join(' ') || l.createdBy.email : '-';
